<template>
  <div>
    <Edit
      :item="currentItem"
      :access="currentAccess"            
      :update="updateItem"      
      :close="closeEdit"
      :descSingular="descSingular"
    ></Edit>
    <div>
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <CTabs variant="tabs" class="nav-tabs-boxed">
            <CTab :title="descPlural">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Imagem</th>
                      <th>Descrição</th>
                      <th>Ordem</th>
                      <th>Visível</th>
                      <th>Link</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in items">
                      <td>
                        <thumb :src="item.imagem"/>
                      </td>
                      <td>{{ item.descricao }}</td>
                      <td>
                        <span class="label primary">{{ item.ordem }}</span>
                      </td>
                      <td>
                        <span class="label success" v-if="item.visivel">Sim</span>
                        <span class="label error" v-else>Não</span>
                      </td>
                      <td>{{ item.link }}</td>
                      <td class="actions">
                        <button type="button" class="button button-primary" v-on:click="openEdit(item)"><fa-icon icon="pencil-alt" /></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CTab>
          </CTabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clone from 'just-clone';
import { get, post, put, del } from '@/helpers/apiRequest';
import Edit from './Edit';

export default {
  name: 'marcas',
  components: {    
    Edit,
  },
  data() {
    return {
      descPlural: '',
      descSingular: '',
      loading: false,
      items: [],      
      modulos: [],
      currentItem: {},
      currentAccess: false,
    };
  },
  methods: {
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem('app'));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === 'ADMIN_MARCA'
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadMarcas() {
      this.loading = true;
      get('/admin/site-marcas')
        .then((json) => {
          this.items = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },    
    openEdit(item, showLoading = true) {
      this.currentItem = clone(item);
      if (showLoading) {
        this.loading = true;
      }
      get(`/admin/site-marcas/${this.currentItem.id}`).then((json) => {
        this.currentAccess = json;
        if (showLoading) {
          this.loading = false;
          this.$modal.show('marcasEdit');
        }
      });
    },
    closeEdit() {
      this.$modal.hide('marcasEdit');      
    },
    updateItem() {
      const { id } = this.currentItem;
      put(`/admin/site-marcas/${id}`, this.currentItem)
        .then((json) => {
          this.closeEdit();
          this.loadMarcas();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });          
        })
        .catch((error) => {
          this.$swal({
            title: 'Falha ao Salvar',
            text: error.message,
            showCancelButton: true,
            cancelButtonText: 'Fechar',
            showConfirmButton: false,
            icon: 'error',
          });
        });
    },
  },
  beforeMount() {
    this.loading = true;
    this.loadMarcas();    
    this.loadDescricaoModulo();
  },
};
</script>
